import { apiFetch } from './client'

export interface AccessEvent {
  id: string
  device_id?: string
  employee_no?: string
  user_name?: string
  user_id?: string
  event_type: string
  door_no?: number
  verify_mode?: string
  pic_url?: string
  occurred_at: string
}

export interface EventFilters {
  deviceId?: string
  employeeNo?: string
  userName?: string
  eventType?: string
  startDate?: string
  endDate?: string
  limit?: number
  offset?: number
}

export const getEvents = (filters: EventFilters = {}) => {
  const params = new URLSearchParams()
  if (filters.deviceId)   params.set('deviceId',   filters.deviceId)
  if (filters.employeeNo) params.set('employeeNo', filters.employeeNo)
  if (filters.userName)   params.set('userName',   filters.userName)
  if (filters.eventType)  params.set('eventType',  filters.eventType)
  if (filters.startDate)  params.set('startDate',  filters.startDate)
  if (filters.endDate)    params.set('endDate',     filters.endDate)
  if (filters.limit  != null) params.set('limit',  String(filters.limit))
  if (filters.offset != null) params.set('offset', String(filters.offset))
  const qs = params.toString()
  return apiFetch<{ events: AccessEvent[] }>(`/events${qs ? `?${qs}` : ''}`)
}
